import * as yup from "yup";

import { IRefundPaymentIssueToMerchantBalance } from "../../../../interfaces-and-types";

export const acceptAsPartialSchema: yup.SchemaOf<IRefundPaymentIssueToMerchantBalance> =
  yup
    .object({
      transfer_refund_id: yup
        .string()
        .required("Please provide the transfer refund id"),
      description: yup.string().nullable().optional().max(300),
    })
    .required();
